import { render, staticRenderFns } from "./StockPerFranchise.vue?vue&type=template&id=2bb07375&"
import script from "./StockPerFranchise.vue?vue&type=script&lang=js&"
export * from "./StockPerFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports